import { Inject, Injectable } from '@angular/core';
import { DataService } from '../http/dataService';
import { ENV, IEnvironment } from 'env/config';

import { Service } from '../entity';
import { CentralApis } from '../interfaces/internal';
import { DropPermission } from '../models/dropPermission.model';
import { Repository } from './repository';

@Service({
  api: 'droppermission',
  model: DropPermission,
})
@Injectable({ providedIn: 'root' })
export class DropPermissionService extends Repository<DropPermission> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).activity,
    });
  }

  createFromDTO(item): DropPermission {
    return new DropPermission(item);
  }
}
